module.exports = __webpack_public_path__ + "static/media/photo87.4609170d.jpg";